export const isInRole = (user, roles) => user && roles.some(r => user.groups.includes(r));

export const isNotInRole = (user, roles) => user && roles.some(r => !user.groups.includes(r));

// This function is action as an object constructor to avoid having to use the new keyword
// React and Redux are not object oriented so using the new keyword might create unwanted bugs and re-render all the time
// The new keyword is not always available, ex: when we want to check Can on formValues
export const abilitySubject = (name, object = {}) => ({ ...object, constructor: { name } });
